import React,{useEffect, useState} from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import { Container, Button, Row} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { getCardDetail } from '../../../actions/cardsActions'
import { addCardaux } from '../../../actions/cardsauxActions'
import FormCardaux from './FormCardaux'
import Swal from 'sweetalert2'
import Loading from '../../../components/design/Modal/Loading'
import { useNavigate } from 'react-router-dom';

export default function CardEdit() {
    const { t } = useTranslation()
    const {id} = useParams()
    const {loading, card} = useSelector(state=>state.cards)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [formState, setFormState] = useState({})
    const {idCard, user, datein, dateout, plot, crop, labor, machinery, litres_gasoil, litres_engine_oil, litres_hydraulic_oil, litres_urea, litres_grease, products, product_extra, irrigation} = formState

    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handleEdit = async(e) => {
        e.preventDefault()

        dispatch(addCardaux(idCard, user, datein, dateout, plot, crop, labor, machinery, litres_gasoil, litres_engine_oil, litres_hydraulic_oil, litres_urea, litres_grease, products, product_extra, irrigation))
        Swal.fire({
            showConfirmButton: true,
            icon: 'success',
            text: t('cardaux.messageadd')
        })
    }

    useEffect(()=>{
        dispatch(getCardDetail(id))
    }, [dispatch,id])

    useEffect(() => {
        if (card) {
            setFormState({
                idCard: card._id,
                user: card.user,
                datein: card.in,
                dateout: card.out,
                plot: card.plot,
                crop: card.crop,
                labor: card.labor,
                machinery: card.machinery,
                litres_gasoil: card.litres_gasoil,
                litres_engine_oil: card.litres_engine_oil,
                litres_hydraulic_oil: card.litres_hydraulic_oil,
                litres_urea: card.litres_urea,
                litres_grease: card.litres_grease,
                products: card.products,
                product_extra: card.product_extra
            })
        }
    }, [card, dispatch, id])

    const goBack = () => {
        navigate('/administrative/cards')
    }

    return (
        <>
            <Container className='cuerpo'>
                <Row className="text-left custom-card-header-list">
                    <Row className="custom-card-buttom">
                        <Button className="btn btn-secondary mb-4 mx-auto" onClick={goBack}>
                            <i className="fas fa-arrow-circle-left"></i> {t('global.return')}
                        </Button>
                    </Row>
                    <h1>{t('cardaux.name')}: <span className='text-uppercase'>{card?.name}</span></h1>
                    <FormCardaux submit={handleEdit} inputChange={handleInputChange} state={formState}></FormCardaux>
                </Row>
            </Container>
            <Loading show={loading}/>
        </>
    )
}
